import React, { useRef, useEffect, useState } from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';

import Modal from './Modal';

const WrappingDiv = styled.div`
    display: flex;
    justify-content: space-between;
    column-gap: 1rem;
    opacity: ${(props) => props.$opacity};
`;

function FilePickerModal(props) {
    const { acceptTypes, handleSelection, handleHide } = props;

    const fileInputRef = useRef(null);
    const autoSelectTriggered = useRef(false);
    const [opacity, setOpacity] = useState(0);

    useEffect(() => {
        // automatically 'click' on the file input label
        if (fileInputRef.current != null && !autoSelectTriggered.current) {
            const clickEvent = new MouseEvent('click', {
                view: window,
            });

            fileInputRef.current.dispatchEvent(clickEvent);

            autoSelectTriggered.current = true;
        }
    }, []);

    useEffect(() => {
        // set the opacity of the ui to zero for two seconds
        const timeoutId = setTimeout(() => {
            setOpacity(1);
        }, 2_000);

        return () => {
            clearTimeout(timeoutId);
        };
    });
    return (
        <Modal>
            <WrappingDiv $opacity={opacity}>
                <label
                    ref={fileInputRef}
                    className="bg-gray-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                >
                    Select File
                    <input
                        className="hidden"
                        type="file"
                        accept={acceptTypes}
                        onChange={(evt) => handleSelection(evt.target.files)}
                    />
                </label>
                <button
                    onClick={handleHide}
                    className="bg-gray-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    type="button"
                >
                    Close
                </button>
            </WrappingDiv>
        </Modal>
    );
}

FilePickerModal.propTypes = {
    acceptTypes: propTypes.string,
    handleSelection: propTypes.func.isRequired,
    handleHide: propTypes.func.isRequired,
};

export default FilePickerModal;
